import React from "react";
import { useForm } from "react-hook-form";
import { Form } from "../../../../../components/ui/common/form";
import { FormInput } from "../../../../../components/ui/Input/FormInput/FormInput";
import { FormInputNumber } from "../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormSelect } from "../../../../../components/ui/Input/FormSelector/FormSelect";
import { FormUnitInput } from "../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM } from "../../../../../config/optionsConstants";
import RecordFormShell from "../../shared/components/recordList/RecordFormShell";
import { MaterialFormValues, PackagingTypeOption } from "../types/packagingMaterial.types";

interface PackagingMaterialFormProps {
  defaultValues: MaterialFormValues;
  packagingTypeData: PackagingTypeOption[];
  isDraft?: boolean;
  title?: string;
  onDelete?: () => void;
  onSave: (values: MaterialFormValues) => void;
  onCancel?: () => void;
  disabled?: boolean;
}

/** Add/edit form for one packaging material — reused for both the inline row editor and the draft panel. */
const PackagingMaterialForm: React.FC<PackagingMaterialFormProps> = ({
  defaultValues,
  packagingTypeData,
  isDraft = false,
  title,
  onDelete,
  onSave,
  onCancel,
  disabled = false
}) => {
  const form = useForm<MaterialFormValues>({ mode: "onChange", defaultValues });

  const handleSubmit = form.handleSubmit(data => onSave(data));

  return (
    <Form {...form}>
      <RecordFormShell
        title={title}
        onDelete={onDelete}
        isDraft={isDraft}
        onCancel={onCancel}
        submitDisabled={disabled || (isDraft && !form.formState.isValid)}
        onSubmit={handleSubmit}
      >
        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2">
          <FormInput
            control={form.control}
            name="name"
            label="Package Name"
            required
            placeholder="e.g., Jute bag"
            errorMessage="Package name is required"
          />
          <FormSelect
            control={form.control}
            name="material"
            label="Packaging material"
            required
            options={packagingTypeData}
            placeholder="Select"
            errorMessage="Packaging material is required"
          />
          <FormUnitInput
            control={form.control}
            name="weight"
            label="Material weight/pk"
            required
            placeholder="0"
            errorMessage="Material weight is required"
            unitName="weightUnit"
            unitOptions={WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM}
          />
          <FormInputNumber
            control={form.control}
            name="cost"
            label="Material cost"
            placeholder="0"
          />
        </div>
      </RecordFormShell>
    </Form>
  );
};

export default PackagingMaterialForm;
